<template>
  <div>
    <div class="bg_invitation">
      <img class="dibu" src="../../img/yaoqin_bg1.png" alt />
      <img class="title" src="../../img/yaoqin_bg2.png" alt />
      <div class="content">
        <p class="bt">{{title}}邀请码</p>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm yaoqinForm"
        >
          <el-form-item prop="yaoqin">
            <el-input v-model="ruleForm.yaoqin" class="yaoqinInput"></el-input>
          </el-form-item>
          <el-button type="primary" class="yaoqinSub" @click="submitForm('ruleForm')">立即创建</el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import $ from "jquery";

export default {
  name: "invitation",
  components: {},
  data() {
    return {
      title: '',
      openid: this.$store.state.openid,
      // openid: "oNrsY1nhE5kjM4DTHPl3IYGpDrIw",
      ruleForm: {
        yaoqin: ""
      },
      rules: {
        yaoqin: [
          { required: true, message: "请输入邀请码", trigger: "blur" },
          { min: 1, max: 8, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    var thisUrl = this.$route.fullPath;
    console.log(this.$route.fullPath, "111");

    if (!this.openid) {
      let code = this.getUrlKey("code");
      if (code) {
        this.$axios.post("/api/auth/wechatinfo?code=" + code).then(res => {
          console.log(res);
          if (res.code == 200) {
            console.log(res.data.original.openid);
            this.openid = res.data.original.openid;
            this.$store.commit("set_openid", res.data.original.openid);
            this.$store.commit("set_userInfo", res.data.original);
            this.info();
          }
          if (res.code == 500) {
            this.info();
          }
        });
      } else {
        this.getCodeApi("123");
      }
    }

    if (thisUrl.indexOf("service_id") != -1) {
      var service_id = this.$route.query.service_id;
      this.$axios
        .get("/api/wechat/info/info", {
          service_id: service_id
        })
        .then(res => {
          console.log(res, 2222222222);
          this.title = res.data;
        });
    }
    if (thisUrl.indexOf("service_id") == -1) {
      this.title = "洪师傅代驾";
    }
  },

  methods: {
    // getHeight(){
    //   $(document).ready(function(){
    //      var windowHeight = $(window).height()
    //      $('.bg_invitation').css('height',windowHeight)
    //   })
    // },
    getUrlKey(name) {//获取url 参数
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
    },
    getCodeApi(state) {
      //获取code
      var thisUrl = this.$route.fullPath;
      if (thisUrl.indexOf("service_id") == -1) {
        this.$axios
          .get("/api/wechat/info/appid", {
            service_id: 2
          })
          .then(res => {
            console.log(res, "获取到appid");
            let urlNow = encodeURIComponent(window.location.href);
            let scope = "snsapi_userinfo"; //snsapi_userinfo   //静默授权 用户无感知
            let appid = "";
            appid = res.data;
            console.log(appid);
            let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
            window.location.replace(url);
          });
      }
      if (thisUrl.indexOf("service_id") != -1) {
        let service_id = this.$route.query.service_id;
        this.$axios
          .get("/api/wechat/info/appid", {
            service_id: service_id
          })
          .then(res => {
            console.log(res, "获取到appid");
            let urlNow = encodeURIComponent(window.location.href);
            let scope = "snsapi_userinfo"; //snsapi_userinfo   //静默授权 用户无感知
            let appid = "";
            appid = res.data;
            console.log(appid);
            let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
            window.location.replace(url);
          });
      }
    },
    submitForm(ruleForm) {
      let service_id = this.$route.query.service_id;
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          this.$axios
            .post("/api/shop/bind", {
              openid: this.openid,
              bind_code: this.ruleForm.yaoqin
            })
            .then(res => {
              if (res.code == 200) {
                // alert(res.message)
                // this.$router.go(-1);
                console.log('yes')
                this.$router.push({ path: '/recommend', query: { service_id: service_id } })
              }
              if (res.code == 422) {
                alert(res.message);
              }
            });
        } else {
          console.log("绑定失败!!");
          return false;
        }
      });
    },
    info() {
      this.$axios
        .post("/api/shop/info", {
          openid: this.openid
        })
        .then(res => {
          // var service_id = this.$route.query.service_id;
          // if (res.code == 422) {
          //   this.$router.push({
          //     path: "invitation",
          //     query: {
          //       service_id: service_id
          //     }
          //   });
          // }
          if (res.code == 200) {
            // this.$store.commit("set_shInfo", res.data);
            // this.qrcode_url = res.data.qrcode_url;
            // this.royalty_money = res.data.royalty_money;
            // this.id = res.data.id;
            // this.$axios
            //   .get("/api/shop/income", {
            //     shop_id: this.id
            //   })
            //   .then(res => {
            //     if (res.code == 200) {
            //       this.symoney = res.data.money;
            //     }
            //   });
            // this.$router.push({
            //   path: "recommend",
            //   query: {
            //     service_id: service_id
            //   }
            // });
            console.log('res.code==200')
            this.$router.push({ path: '/recommend', query: { service_id: this.$route.query.service_id } })
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
.bg_invitation {
  width: 750px;
  height: 100vh;
  margin: 0px auto;
  position: relative;
  background-image: url("../../img/yaoqin_bg.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .title {
    width: 500px;
    margin-top: 125px;
    margin-bottom: 100px;
  }
  .dibu {
    width: 80%;
    position: absolute;
    bottom: 50px;
    left: 10%;
  }
  .content {
    width: 566px;
    height: 566px;
    margin: 0px auto;
    background-image: url("../../img/coin.png");
    display: flex;
    position: relative;
    .bt {
      position: absolute;
      text-align: center;
      width: 100%;
      top: 73px;
      font-size: 36px;
      color: #d19427;
    }
  }
}
.yaoqinForm {
  width: 300px;
  margin-left: 100px;
  margin-top: 195px;
}
.yaoqinSub {
  margin-top: 140px;
  width: 330px;
}
@media screen and (max-width: 750px) {
  .bg_invitation {
    width: 100%;
  }
}
@media screen and (min-width: 750px) {
}
</style>
<style lang="less">
.yaoqinForm {
  .el-input__inner {
    border: 0px;
    font-size: 36px;
    height: 50px;
    line-height: 50px;
  }
  .el-form-item__error {
    padding-top: 15px;
    font-size: 16px;
  }
  .el-button {
    padding: 25px 20px;
    opacity: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/invitation/invitation.vue